module.exports = __webpack_public_path__ + "static/media/blur.1c179f8f.jpg";